import { http } from "../api/http";
import Utils from "../utils";

export const azureCostService = {
  get,
  getById,
  create,
  upsert,
  bulkUpsert,
  update,
  remove,
  getDaily,
  getMonthly,
  getQuarterly,
  getSubscriptions,
  getDailyForChart,
  getMonthlyForChart,
  getQuarterlyForChart,
};

function get(requestParameters) {
  let url = `/azure-cost?${Utils.objectToQueryString(requestParameters)}`;

  return http.get(url).then((response) => {
    return response;
  });
}

function getById(id) {
  let url = `/azure-cost/${id}`;

  return http.get(url).then((response) => {
    return response;
  });
}

function create(requestBody) {
  let url = `/azure-cost/create`;

  return http.post(url, JSON.stringify(requestBody)).then((response) => {
    return response;
  });
}

function upsert(requestBody) {
  let url = `/azure-cost/upsert`;

  return http.post(url, JSON.stringify(requestBody)).then((response) => {
    return response;
  });
}

function bulkUpsert(costs) {
  let url = `/azure-cost/bulk-upsert`;

  return http.post(url, JSON.stringify({ costs })).then((response) => {
    return response;
  });
}

function update(requestBody) {
  let url = `/azure-cost/update`;

  return http.patch(url, JSON.stringify(requestBody)).then((response) => {
    return response;
  });
}

function remove(id) {
  let url = `/azure-cost/delete?id=${id}`;

  return http.delete(url).then((response) => {
    return response;
  });
}

function getDaily(requestParameters) {
  let url = `/azure-cost/daily?${Utils.objectToQueryString(requestParameters)}`;

  return http.get(url).then((response) => {
    return response;
  });
}

function getMonthly(requestParameters) {
  let url = `/azure-cost/monthly?${Utils.objectToQueryString(requestParameters)}`;

  return http.get(url).then((response) => {
    return response;
  });
}

function getQuarterly(requestParameters) {
  let url = `/azure-cost/quarterly?${Utils.objectToQueryString(requestParameters)}`;

  return http.get(url).then((response) => {
    return response;
  });
}

function getSubscriptions() {
  let url = `/azure-cost/subscriptions`;

  return http.get(url).then((response) => {
    return response;
  });
}

// Chart-specific functions that fetch larger datasets.
// These request the MOST RECENT periods (order_direction=Desc): the API
// defaults to oldest-first, so paging without a sort would return the earliest
// rows and silently drop recent data past the page size (e.g. only showing
// through the end of the first year). The chart components re-sort ascending
// before rendering, so descending here only controls which window is fetched.
function getDailyForChart(requestParameters) {
  // Fetch the most recent 365 days for charts
  const chartParams = {
    ...requestParameters,
    pageSize: 365,
    pageNumber: 1,
    order_by: "CostDate",
    order_direction: "Desc",
  };
  let url = `/azure-cost/daily?${Utils.objectToQueryString(chartParams)}`;

  return http.get(url).then((response) => {
    return response;
  });
}

function getMonthlyForChart(requestParameters) {
  // Fetch the most recent 24 months for charts
  const chartParams = {
    ...requestParameters,
    pageSize: 24,
    pageNumber: 1,
    order_by: "Year",
    order_direction: "Desc",
  };
  let url = `/azure-cost/monthly?${Utils.objectToQueryString(chartParams)}`;

  return http.get(url).then((response) => {
    return response;
  });
}

function getQuarterlyForChart(requestParameters) {
  // Fetch the most recent 12 quarters for charts
  const chartParams = {
    ...requestParameters,
    pageSize: 12,
    pageNumber: 1,
    order_by: "Year",
    order_direction: "Desc",
  };
  let url = `/azure-cost/quarterly?${Utils.objectToQueryString(chartParams)}`;

  return http.get(url).then((response) => {
    return response;
  });
}
